import { SearchFormConfig } from '@awaze/design-system.compositions.search-form'
import { GoogleSearchMethods } from '@awaze/mfe-common.api.places-api'

export const FUSION_DATE_FORMAT = 'dd-MM-yyyy'
export const DEFAULT_SEARCH_CRITERIA = {
  adult: 2,
  child: 0,
  infant: 0,
  pets: 0,
  nights: 7,
  range: 3,
  accommodationType: 'cottages',
}

export type Environment = 'dev' | 'pprd' | 'prd'
type PlacesTypes =
  | 'Location'
  | 'l'
  | 'TouristicTerm'
  | 't'
  | 'GooglePlacesApiAutocomplete'

export interface FormData {
  id?: string
  adult: string
  child: string
  destination?: string
  destinationId?: string
  destinationURL?: string
  featureId?: string
  infant: string
  nights: string
  pets: string
  range: string
  start?: string
  accommodationType?: string
  placesDrupalLegacyId?: string
}

export interface SearchFormProps {
  config?: SearchFormConfig
  isSummary?: boolean
  placesConfig?: PlacesSearchConfigType
}

export interface SearchResult {
  id: string | number
  name: string
  link: string
  subtitle?: string
  property?: boolean
  drupalId?: string | null
  legacyId?: string
  drupalLegacyId?: string
  type?: PlacesTypes
  t?: boolean | null
}

interface DestinationListPopular {
  name?: string | null
  title?: string | null
  locations?: DestinationListLocation[] | []
}

export interface DestinationListLocation {
  id: string | number
  parentId: string | null
  name: string
  legacyId?: string
  drupalId?: string | null
  has_children?: boolean | null
  houses?: number | null
  type?: PlacesTypes
  t?: boolean | null
  popular?: DestinationListPopular
}

export interface DestinationListResult {
  id: string | null
  parentId: string | null
  name: string | null
  legacyId?: string
  drupalId?: string
  locations?: DestinationListLocation[] | []
  popular?: DestinationListPopular
}

export type PlacesSearchConfigType = {
  useLegacyDestinationSelector?: boolean
  initialParentDestinationList?: string | null
  pageSize?: number | null
  pageSizePopular?: number | null
  googleFallbackMethod?: GoogleSearchMethods
}

export type Suggestion = {
  id: string
  name: string
  link: string
  subtitle?: string
  parentName?: string
  countryName?: string
  type?: PlacesTypes
}
export type PlacesSuggestions = (searchTerm: string) => Promise<Suggestion[]>
